import { IFeatureBase, IFeatureGroupBase } from '../../models/features';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateFeatureGroupProps {
  featureGroupId: string;
  authLevel: number;
  key: string;
  features: IFeatureBase[];
  name: string;
  useExperienceLevel: boolean;
  useFaceId: boolean;
  useOnboardUrl: boolean;
}

export type IUpdatedFeatureGroup = IFeatureGroupBase;

export const updateFeatureGroupsService = async ({
  featureGroupId,
  authLevel,
  key,
  features,
  name,
  useExperienceLevel,
  useFaceId,
  useOnboardUrl,
}: IUpdateFeatureGroupProps): Promise<IUpdatedFeatureGroup> => {
  const { data } = await jhsfBookingsApi.put<IUpdatedFeatureGroup>(
    `/feature-groups/${featureGroupId}`,
    {
      authLevel,
      key,
      features,
      name,
      useExperienceLevel,
      useFaceId,
      useOnboardUrl,
    },
  );

  return data;
};
